import React from "react";

const BASE = process.env.PUBLIC_URL || "";

const SOURCES = {
  // Lockup completo (emblema + KROMA + "Smart String Art")
  full: {
    dark: `${BASE}/brand/kroma-logo.png`,
    light: `${BASE}/brand/kroma-logo-light.png`,
  },
  // Versão compacta para barras de navegação (emblema + KROMA)
  compact: {
    dark: `${BASE}/brand/kroma-logo-compact.png`,
    light: `${BASE}/brand/kroma-logo-compact-light.png`,
  },
};

const MARK = `${BASE}/brand/kroma-mark.png`;

/**
 * Logomarca KROMA — Smart String Art.
 *
 * props:
 *  - full:      lockup completo com o slogan (por omissão usa a versão compacta)
 *  - mark:      apenas o símbolo circular
 *  - variant:   "dark" (texto escuro, predefinição) | "light" (texto branco)
 *  - className: controla o tamanho (usar altura, ex.: "h-11 w-auto")
 */
export default function Logo({
  full = false,
  mark = false,
  variant = "dark",
  className = "h-11 w-auto",
  alt = "KROMA — Smart String Art",
  ...rest
}) {
  const set = SOURCES[full ? "full" : "compact"];
  const src = mark ? MARK : set[variant] || set.dark;
  return (
    <img
      src={src}
      alt={alt}
      draggable={false}
      className={`${className} object-contain select-none shrink-0`}
      {...rest}
    />
  );
}
